// extracted by mini-css-extract-plugin
export default {"commentBox":"syx9ZP"};